import React, { useState, useEffect } from "react";

import cx from 'classnames';
import { useInView } from 'react-intersection-observer';

import styles from './infiniteScroll.module.scss';
import { Button } from "react-bootstrap";

export default function InfiniteScroll({ className, children, loading, hasMore, loadMore, containerRef, error, hideLoadMoreButton }) {
  const { ref, inView, entry } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if(inView && hasMore && !error){
      loadMoreItems();
    }
  }, [inView, hasMore]);

  const loadMoreItems = () => {
    if(!loading && !error){
      loadMore();
    }
  }

  return (
    <div ref={containerRef} id='infinite-scroll' className={cx(styles.infiniteScroll, className)}>
      {children}
      <div>
        {hasMore && loading && !error &&
          <div className={cx(styles.loading)}>Loading more items...</div>
        }

        {hasMore && !loading && !error &&
          <Button ref={ref} className={cx(styles.loadMore, { [styles.hidden]: hideLoadMoreButton })} variant='outline'>Load More</Button>
        }
      </div>
    </div>

  );
}